export const DeviceType = {
  Vp3701: 'vp-3701',
  Vp3711: 'vp-3711',
  Generator: 'generator',
  Controller: 'controller'
} as const

export const DeviceNodeType = {
  Group: 'group',
  Device: 'device',
  Module: 'module',
  Channel: 'channel'
} as const

export const DeviceGroupLabel = {
  Vp3701RootGroup: 'Устройства VP-3701',
  GeneratorRootGroup: 'Генераторы',
  Vp3711RootGroup: 'Измерительные посты VP-3711',
  ControllerRootGroup: 'Контроллеры'
} as const

export const DeviceRootKey = {
  Vp3701: '1',
  Vp3711: '2',
  Generator: '3',
  Controller: '4'
}

export const DeviceRoute = {
  GeneratorGroupId: `${DeviceType.Generator}/${DeviceNodeType.Group}/:id`,
  GeneratorGroupAdd: `${DeviceType.Generator}/${DeviceNodeType.Group}/:id/add-group`,
  GeneratorAdd: `${DeviceType.Generator}/${DeviceNodeType.Group}/:id/add-generator`,
  GeneratorId: `${DeviceType.Generator}/${DeviceNodeType.Device}/:id`,
  Vp3701GroupId: `${DeviceType.Vp3701}/${DeviceNodeType.Group}/:id`,
  Vp3701GroupAdd: `${DeviceType.Vp3701}/${DeviceNodeType.Group}/:id/add-group`,
  Vp3701DeviceId: `${DeviceType.Vp3701}/${DeviceNodeType.Device}/:id`,
  Vp3701BatteryMonitoring: 'battery-monitoring',
  Vp3701ModuleId: `${DeviceType.Vp3701}/${DeviceNodeType.Module}/:id`,
  Vp3701ChannelId: `${DeviceType.Vp3701}/${DeviceNodeType.Channel}/:id`,
  Vp3711GroupId: `${DeviceType.Vp3711}/${DeviceNodeType.Group}/:id`,
  Vp3711GroupAdd: `${DeviceType.Vp3711}/${DeviceNodeType.Group}/:id/add-group`,
  Vp3711MeasurementPostId: `${DeviceType.Vp3711}/${DeviceNodeType.Device}/:id`,
  Vp3711ModuleId: `${DeviceType.Vp3711}/${DeviceNodeType.Module}/:id`,
  Vp3711ChannelId: `${DeviceType.Vp3711}/${DeviceNodeType.Channel}/:id`,
  ControllerGroupId: `${DeviceType.Controller}/${DeviceNodeType.Group}/:id`,
  ControllerGroupAdd: `${DeviceType.Controller}/${DeviceNodeType.Group}/:id/add-group`,
  ControllerId: `${DeviceType.Controller}/${DeviceNodeType.Device}/:id`,
  ControllerChannelId: `${DeviceType.Controller}/${DeviceNodeType.Channel}/:id`
} as const
